var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from "framer";
import { useCallback, useRef, useState } from "react";
import styled from "styled-components";
import { BaseButton, Title } from "../../designSystem";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
import theme from "../../designSystem/theme";
import { useBoundingclientrect } from "../../hooks/useBoundingclientrect";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import useScreenSize from "../../hooks/useScreenSize";
import { capitalize } from "../../utils/text";
import ButtonArrow from "./ButtonArrow";
import ExternalLink from "../../assets/icons/externalLink";
var Filter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var FilterButton = styled(BaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  background-color: ", ";\n  opacity: ", ";\n  &:hover {\n    background-color: ", ";\n    opacity: 1;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  background-color: ", ";\n  opacity: ", ";\n  &:hover {\n    background-color: ", ";\n    opacity: 1;\n  }\n"])), function (props) {
    return (props.config.paddingVertical || 8) + "px " + (props.config.paddingHorizontal || 12) + "px";
}, function (props) {
    return props.active
        ? props.config.activeBackground || colors.background.two
        : props.config.background || colors.background.two;
}, function (props) {
    return props.active || props.config.onPage
        ? "1"
        : props.config.header
            ? "0.48"
            : "1";
}, function (props) {
    return props.config.activeBackground || colors.background.two;
});
var FilterButtonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  text-transform: uppercase;\n"], ["\n  font-size: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  text-transform: uppercase;\n"])), function (props) { return (props.config.header ? "12px" : "14px"); }, function (props) { return (props.config.header ? "1.5px" : ""); }, function (props) { return props.config.color || colors.text; });
var FilterDropdownMenu = styled(motion.div)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.isOpen
        ? "\n          position: absolute;\n          z-index: 2000;\n          " + (function () {
            switch (props.config.horizontalOrientation) {
                case "left":
                    return "left: 0px;";
                case "right":
                default:
                    return "right: 0px;";
            }
        })() + "\n          " + (function () {
            switch (props.verticalOrientation) {
                case "top":
                    return "bottom: 48px;";
                case "bottom":
                default:
                    return "top: calc(21px + " + props.buttonPaddingVertical * 2 + "px + " + props.config.topBuffer + "px);";
            }
        })() + "\n          width: fit-content;\n          background-color: " + (props.config.backgroundColor || colors.background.two) + ";\n          border-radius: " + theme.border.radius + ";\n        "
        : "\n          display: none;\n        ";
});
var MenuItem = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", ";\n  opacity: 1;\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    padding-top: ", ";\n  }\n\n  &:last-child {\n    padding-bottom: ", ";\n  }\n\n  svg {\n    opacity: 0.64;\n  }\n\n  &:hover {\n    span {\n      color: ", ";\n    }\n    svg {\n      opacity: 1;\n    }\n  }\n"], ["\n  padding: ", ";\n  opacity: 1;\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    padding-top: ", ";\n  }\n\n  &:last-child {\n    padding-bottom: ", ";\n  }\n\n  svg {\n    opacity: 0.64;\n  }\n\n  &:hover {\n    span {\n      color: ", ";\n    }\n    svg {\n      opacity: 1;\n    }\n  }\n"])), function (props) { return props.padding || "8px 66px 8px 16px"; }, function (props) {
    return props.firstItemPaddingTop ? props.firstItemPaddingTop : "16px";
}, function (props) {
    return props.lastItemPaddingBottom ? props.lastItemPaddingBottom : "16px";
}, colors.primaryText);
var MenuItemText = styled(Title)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", "A3;\n  white-space: nowrap;\n"], ["\n  color: ", "A3;\n  white-space: nowrap;\n"])), colors.primaryText);
var FilterDropdown = function (_a) {
    var options = _a.options, value = _a.value, onSelect = _a.onSelect, _b = _a.buttonConfig, buttonConfig = _b === void 0 ? {} : _b, _c = _a.dropdownMenuConfig, dropdownMenuConfig = _c === void 0 ? {
        topBuffer: 8,
    } : _c, menuItemConfig = _a.menuItemConfig, menuItemTextConfig = _a.menuItemTextConfig, props = __rest(_a, ["options", "value", "onSelect", "buttonConfig", "dropdownMenuConfig", "menuItemConfig", "menuItemTextConfig"]);
    var ref = useRef(null);
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useScreenSize(), height = _e.height, width = _e.width;
    var dropdownBoundingRect = useBoundingclientrect(ref);
    useOutsideAlerter(ref, function () {
        setOpen(false);
    });
    var renderMenuItem = useCallback(function (title, externalLink, onClick) { return (_jsxs(MenuItem, __assign({ onClick: onClick, role: "button" }, menuItemConfig, { children: [_jsx(MenuItemText, __assign({ fontSize: (menuItemTextConfig === null || menuItemTextConfig === void 0 ? void 0 : menuItemTextConfig.fontSize) || 14, letterSpacing: (menuItemTextConfig === null || menuItemTextConfig === void 0 ? void 0 : menuItemTextConfig.letterSpacing) || undefined, lineHeight: (menuItemTextConfig === null || menuItemTextConfig === void 0 ? void 0 : menuItemTextConfig.lineHeight) || 20 }, { children: title }), void 0), externalLink && (_jsx("div", __assign({ className: "ml-2" }, { children: _jsx(ExternalLink, {}, void 0) }), void 0))] }), title)); }, [
        menuItemConfig,
        menuItemTextConfig === null || menuItemTextConfig === void 0 ? void 0 : menuItemTextConfig.fontSize,
        menuItemTextConfig === null || menuItemTextConfig === void 0 ? void 0 : menuItemTextConfig.letterSpacing,
        menuItemTextConfig === null || menuItemTextConfig === void 0 ? void 0 : menuItemTextConfig.lineHeight,
    ]);
    var getVerticalOrientation = useCallback(function () {
        /**
         * Height of dropdown: 48px
         * Height of each option: 36px
         * Total dropdown margin: 16px
         */
        if (dropdownBoundingRect &&
            dropdownBoundingRect.top +
                48 +
                options.length * 36 +
                16 +
                (width > sizes.lg
                    ? theme.footer.desktop.height
                    : theme.footer.mobile.height) >
                height) {
            return "top";
        }
        return "bottom";
    }, [width, height, dropdownBoundingRect, options]);
    return (_jsxs(Filter, __assign({}, props, { ref: ref }, { children: [_jsx(FilterButton, __assign({ role: "button", active: open, onClick: function () {
                    setOpen(function (open) { return !open; });
                }, config: buttonConfig }, { children: _jsxs(FilterButtonText, __assign({ config: buttonConfig }, { children: [value, " ", _jsx(ButtonArrow, { isOpen: open, color: buttonConfig.color }, void 0)] }), void 0) }), void 0), _jsx(AnimatePresence, { children: _jsx(FilterDropdownMenu, __assign({ isOpen: open, verticalOrientation: getVerticalOrientation(), buttonPaddingVertical: buttonConfig.paddingVertical || 8, config: dropdownMenuConfig, initial: {
                        opacity: 0,
                        y: 20,
                    }, animate: {
                        opacity: 1,
                        y: 0,
                    }, exit: {
                        opacity: 0,
                        y: 20,
                    }, transition: {
                        type: "keyframes",
                        duration: 0.2,
                    } }, { children: options.map(function (filterOption) {
                        return typeof filterOption === "string"
                            ? renderMenuItem(capitalize(filterOption), false, function () {
                                onSelect(filterOption);
                                setOpen(false);
                            })
                            : renderMenuItem(capitalize(filterOption.display), filterOption.externalLink
                                ? filterOption.externalLink
                                : false, function () {
                                onSelect(filterOption.value);
                                setOpen(false);
                            });
                    }) }), open.toString()) }, void 0)] }), void 0));
};
export default FilterDropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=FilterDropdown.js.map